import React from "react";

const TableShimmer = ({
  isSharedAccount = false,
  showActions = true,
  hasAccountColumn = false,
  colReceivedTitle = "Amount Received",
  colGivenTitle = "Amount Given",
  height = "calc(100vh - 225px)",
}) => {
  return (
    <div className="w-100 p-0 m-0 animate__animated animate__fadeIn">
      {/* Table Structure Shimmer */}
      <div
        className="table-responsive scrollbar-design w-100 p-0"
        style={{
          height,
          maxHeight: height,
          overflowY: "auto",
        }}
      >
        <table className="table table-hover align-middle mb-0 khata-statement-table">
          <thead className="table-light position-sticky top-0 z-1 border-bottom">
            <tr>
              <th
                scope="col"
                className="text-start py-3 px-3 text-secondary text-nowrap"
                style={{ width: "130px" }}
              >
                Txn Date
              </th>
              {hasAccountColumn && (
                <th
                  scope="col"
                  className="text-start py-3 px-2 text-secondary text-nowrap"
                  style={{ width: "160px" }}
                >
                  Account
                </th>
              )}
              <th scope="col" className="text-start py-3 px-2 text-secondary">
                Description
              </th>
              <th
                scope="col"
                className="text-end py-3 px-3 text-secondary text-nowrap"
                style={{ width: "140px" }}
              >
                {colReceivedTitle}
              </th>
              <th
                scope="col"
                className="text-end py-3 px-3 text-secondary text-nowrap"
                style={{ width: "140px" }}
              >
                {colGivenTitle}
              </th>
              <th
                scope="col"
                className="text-end py-3 px-2 text-secondary text-nowrap"
                style={{ width: "110px" }}
              >
                Balance
              </th>
              {!isSharedAccount && showActions && (
                <th
                  scope="col"
                  className="text-center py-3 px-2 text-secondary"
                  style={{ width: "50px" }}
                />
              )}
            </tr>
          </thead>
          <tbody>
            {[...Array(8)].map((_, i) => (
              <tr key={i} className="border-bottom">
                {/* Date */}
                <td className="text-start py-2 px-3 text-nowrap">
                  <div
                    className="shimmer-wrapper"
                    style={{ width: "85px", height: "18px" }}
                  />
                </td>
                {/* Account */}
                {hasAccountColumn && (
                  <td className="text-start py-2 px-2 text-nowrap">
                    <div
                      className="shimmer-wrapper"
                      style={{ width: "120px", height: "18px" }}
                    />
                  </td>
                )}
                {/* Description */}
                <td className="text-start py-2 px-2">
                  <div
                    className="shimmer-wrapper"
                    style={{
                      width: i % 2 === 0 ? "200px" : "140px",
                      height: "18px",
                    }}
                  />
                </td>
                {/* Received / Cash In */}
                <td className="text-end py-2 px-3 text-nowrap" align="right">
                  {i % 2 === 0 ? (
                    <div
                      className="shimmer-wrapper ms-auto"
                      style={{ width: "70px", height: "18px" }}
                    />
                  ) : null}
                </td>
                {/* Given / Cash Out */}
                <td className="text-end py-2 px-3 text-nowrap" align="right">
                  {i % 2 !== 0 ? (
                    <div
                      className="shimmer-wrapper ms-auto"
                      style={{ width: "70px", height: "18px" }}
                    />
                  ) : null}
                </td>
                {/* Balance */}
                <td className="text-end py-2 px-2 text-nowrap" align="right">
                  {i % 3 === 0 && (
                    <div
                      className="shimmer-wrapper ms-auto"
                      style={{
                        width: "30px",
                        height: "22px",
                        borderRadius: "4px",
                      }}
                    />
                  )}
                </td>
                {/* Actions */}
                {!isSharedAccount && showActions && (
                  <td className="text-center py-2 px-2 text-nowrap" align="center">
                    <div
                      className="shimmer-wrapper mx-auto"
                      style={{
                        width: "14px",
                        height: "14px",
                        borderRadius: "50%",
                      }}
                    />
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableShimmer;
